import { GET_LIVECHAT_STATUS } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

export interface LiveChatState extends BaseAsyncReducerState {
    enabled: boolean
}

const initialState: LiveChatState = {
    enabled: true,
    loading: false,
    error: false
}

function liveChatReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case GET_LIVECHAT_STATUS.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case GET_LIVECHAT_STATUS.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,
            }
        case GET_LIVECHAT_STATUS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        default:
            return state
    }
}

export default liveChatReducer;